var ClinicNonTimedTriggerMedicationRequest = /** @class */ (function () {
    function ClinicNonTimedTriggerMedicationRequest(_a) {
        var PublicToken = _a.PublicToken;
        this.Action = 'clinicnontimedtriggermedication';
        this.PublicToken = PublicToken;
    }
    return ClinicNonTimedTriggerMedicationRequest;
}());
export { ClinicNonTimedTriggerMedicationRequest };
